import { memo } from 'react';
import classNames from 'classnames';
import styles from './ProductVariantButton.module.scss';

function ProductVariantButton({
  inStock,
  label,
  onClick,
  selectedSKU,
  SKU,
  storeSelection,
}) {
  const isSelectable = SKU !== selectedSKU && inStock && storeSelection;
  const isSelected = SKU === selectedSKU && inStock && storeSelection;
  const isSelectedOOS = SKU === selectedSKU && !inStock && storeSelection;
  const isOOS = !inStock || !storeSelection;

  const ariaLabel = isSelected
    ? `${label} variation, selected`
    : isSelectedOOS
    ? `${label} variation, selected, out of stock`
    : isOOS
    ? `${label} variation, out of stock`
    : `Select ${label} variation`;

  return (
    <button
      aria-label={ariaLabel}
      className={classNames('btn fs-7 fs-sm-8 px-5 py-4 w-100', styles.button, {
        [styles.variant_button]: isSelectable,
        [styles.selected_button]: isSelected,
        [styles.selected_button_ooo]: isSelectedOOS,
        [styles.out_of_stock_button]: isOOS,
      })}
      data-value="product-variant-button"
      type="button"
      onClick={onClick}
    >
      {label}
    </button>
  );
}

export default memo(ProductVariantButton);
